import Typography from "@mui/material/Typography";
import {Button} from "@mui/material";
import ContentCopyRoundedIcon from "@mui/icons-material/ContentCopyRounded";
import {useContext, useState} from "react";
import ConfigContext from "../../../context/ConfigContext";
import {useSnackbar} from "notistack";
import useCallDataApi from "../../../hooks/data";
import Loading from "../../../components/Loading";
import useBusinessQueries from "../../../hooks/queries/useBusinessQueries";

const Calendar = () => {
    const {baseUrl} = useContext(ConfigContext)
    const {businessGetCalendarSlugQuery} = useBusinessQueries()
    const {enqueueSnackbar} = useSnackbar()

    const copyCalendarLink = async () => {
        try {
            const response = await businessGetCalendarSlugQuery.refetch();
            if (response.isError) {
                throw response.error;
            }
            const { slug } = response.data;
            await navigator.clipboard.writeText(baseUrl + '/business-cal/' + slug);
            enqueueSnackbar('Másolva!', { variant: 'success' });
        } catch (err) {
            console.error(err);
            enqueueSnackbar('Hiba történt a másolás közben!', { variant: 'error' });
        }
    };

    if (businessGetCalendarSlugQuery.isFetching) return <Loading isLoading />

    return <div className="white-card">
        <Typography variant='subtitle2'>Naptár megosztása</Typography>
        <Typography variant='body2' color='#536B74' gutterBottom>
            Ezzel a linkkel tudod beállítani a
            Google és egyéb naptáraidat.
        </Typography>
        <Button
            variant='contained'
            sx={{marginTop: 2}}
            onClick={() => copyCalendarLink()}
            endIcon={<ContentCopyRoundedIcon/>}>
            Link másolása
        </Button>

    </div>
}

export default Calendar